import styled from "styled-components";

export const ModalStyle = styled.div`
  position: relative;
  width: 100%;
  height: fit-content;
  display: flex;
  flex-direction: column;
  align-items: center;
  outline: none;
  /* box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1),
    0 10px 10px -5px rgba(0, 0, 0, 0.04); */
  opacity: 0;
  transform: translateY(14px) scale(0.985);
  transition:
    opacity ${(props) => props.$animationDuration || 300}ms var(--ease-snappy),
    transform ${(props) => props.$animationDuration || 300}ms var(--ease-snappy);
  padding-inline: 12px;

  &[class*="--after-open"] {
    opacity: 1;
    transform: translateY(0) scale(1);
  }

  &[class*="--before-close"] {
    opacity: 0;
    transform: translateY(14px) scale(0.985);
  }
`;

export const OverlayStyle = styled.div`
  position: fixed;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;

  z-index: 1000;
  background:
    radial-gradient(
      circle at 50% 30%,
      rgba(var(--color-brand-400-rgb), 0.18),
      transparent 55%
    ),
    rgba(15, 47, 84, 0.32);
  backdrop-filter: blur(18px) saturate(140%);
  -webkit-backdrop-filter: blur(18px) saturate(140%);
  transition: opacity 220ms ease;

  ${(props) =>
    props.$customStyles && typeof props.$customStyles === "object"
      ? Object.entries(props.$customStyles)
          .map(
            ([key, value]) =>
              `${key.replace(/([A-Z])/g, "-$1").toLowerCase()}: ${value};`,
          )
          .join("\n")
      : ""}/* @media (max-width: 768px) {
    align-items: ${(p) => (!p.$collectionModal ? "center" : "flex-start")};
  } */
`;
